import React, { memo, useMemo, lazy, Suspense, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
// FIX (Increment 5, bundle-size regression): was `import { Loading } from
// 'components/shared'` -- this file (and views/index.js, and several
// components/template/* chrome files) is part of every authenticated
// page's layout chunk, never behind its own React.lazy() boundary the way
// route *content* is. Importing from the shared *barrel* pulled in that
// module's entire re-export graph -- including Chart.js (apexcharts),
// CalendarView.js (@fullcalendar + its CSS) and RichTextEditor.js
// (react-quill + its CSS) -- into that same chunk, so those heavy libs
// loaded on every page despite every route already being React.lazy()'d.
// A direct import only touches Loading.js itself.
import Loading from 'components/shared/Loading'
import {
	LAYOUT_TYPE_CLASSIC,
	LAYOUT_TYPE_MODERN,
	LAYOUT_TYPE_SIMPLE,
	LAYOUT_TYPE_STACKED_SIDE,
	LAYOUT_TYPE_DECKED,
	LAYOUT_TYPE_BLANK
} from 'constants/theme.constant'
import useAuth from 'utils/hooks/useAuth'
import useDirection from 'utils/hooks/useDirection'
import useLocale from 'utils/hooks/useLocale'
import { onSignOutSuccess } from 'store/auth/sessionSlice'
import { initialState, setUser } from 'store/auth/userSlice'

const layouts = {
	[LAYOUT_TYPE_CLASSIC]: lazy(() => import('./ClassicLayout')),
	[LAYOUT_TYPE_MODERN]: lazy(() => import('./ModernLayout')),
	[LAYOUT_TYPE_STACKED_SIDE]: lazy(() => import('./StackedSideLayout')),
	[LAYOUT_TYPE_SIMPLE]: lazy(() => import('./SimpleLayout')),
	[LAYOUT_TYPE_DECKED]: lazy(() => import('./DeckedLayout')),
	[LAYOUT_TYPE_BLANK]: lazy(() => import('./BlankLayout')),
}

const Layout = () => {
	const layoutType = useSelector((state) => state.theme.layout.type)
	const { authenticated, signOut } = useAuth() // Make sure signOut is available
	const navigate = useNavigate()
	const dispatch = useDispatch()

	useDirection()
	useLocale()

	// ✅ URL-based logout logic
	useEffect(() => {
		const currentUrl = window.location.pathname
		const logoutTriggerUrl = '/payee-payment' // Change to the URL that should trigger logout

		if (authenticated && currentUrl.includes(logoutTriggerUrl)) {
			debugger
			dispatch(onSignOutSuccess())
			dispatch(setUser(initialState))
			localStorage.clear('items')
			window.location.reload()
		}
	}, [authenticated, navigate])

	const AppLayout = useMemo(() => {
		if (authenticated) {
			return layouts[layoutType]
		}
		return lazy(() => import('./AuthLayout'))
	}, [layoutType, authenticated])

	return (
		<Suspense
			fallback={
				<div className="flex flex-auto flex-col h-[100vh]">
					<Loading loading={true} />
				</div>
			}
		>
			<AppLayout />
		</Suspense>
	)
}

export default memo(Layout)
